import { render, staticRenderFns } from "./individual.vue?vue&type=template&id=57384714&"
import script from "./individual.vue?vue&type=script&lang=js&"
export * from "./individual.vue?vue&type=script&lang=js&"
import style0 from "./individual.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports